import type { ComponentProps } from 'react';
import { createPortal } from 'react-dom';

import { keepSelection as preventFocusLoss } from './styles';

type EditorPortalProps = ComponentProps<'div'> & {
  /** Cancel mouse-down so clicks keep the editor's selection; off for panels with their own inputs. */
  keepSelection?: boolean;
};

/**
 * A `div` rendered into `document.body`, for every floating editor UI (menus, toolbars, overlays).
 * - Escapes the editor's stacking and overflow context, as `FroalaInput` does with its popups.
 * - `data-lexical-portal` tells the editor chrome this is still "inside" the editor, so it stays focused.
 */
export const EditorPortal = ({ keepSelection = true, onMouseDown, ...props }: EditorPortalProps) =>
  createPortal(
    <div
      data-lexical-portal
      onMouseDown={(e) => {
        if (keepSelection) preventFocusLoss(e);
        onMouseDown?.(e);
      }}
      {...props}
    />,
    document.body,
  );
